angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('accounting', {
    url: "/accounting",
    template: '<div ui-view></div>',
    redirectTo: 'accounting.import'
  }).state('accounting.import', {
    url: "/import",
    template: require('./views/import.html'),
    controller: 'QuickbooksImportCtrl'
  }).state('accounting.import.edit', {
    url: "/edit",
    views: {
      'edit': {
        template: require('./views/customer.edit.html'),
        controller: 'CustomerEditCtrl'
      }
    },
    params: {
      client: null,
      matter: null
    }
  }).state('accounting.import.clientsearch', {
    url: "/clientsearch/{id}",
    views: {
      'edit': {
        template: require('./views/import.clientsearch.html'),
        controller: 'ClientsImportCtrl'
      }
    }
  }).state('accounting.export', {
    url: "/export",
    template: require('./views/export.html'),
    controller: 'ClientsExportCtrl'
  }).state('clients.qbsearch', {
    url: "/qbsearch/{clientId}/{name}",
    views: {
      'edit': {
        template: require('./views/qbsearch.html'),
        controller: 'ClientsQBSearchCtrl'
      }
    }
  });
}]);